import { type ApplicationModelClient } from './client';

/**
 * Stub client for tests and using model classes without an API
 */
export default class NullClient implements ApplicationModelClient {
  apiError(error: { message?: string }) {
    console.error(`NullClient API error: ${error.message}`);
  }

  evict(options = {}) {
    // Do nothing
  }

  cacheId(attributes: { __typename?: string; id?: string } = {}) {
    return `${attributes.__typename}:${attributes.id}`;
  }

  async query<T>(queryString: string, options = {}) {
    console.info('Ignoring query on null client');
    return Promise.resolve({} as T);
  }

  async mutate<T>(mutationString: string, options = {}) {
    console.info('Ignoring mutate on null client');
    return Promise.resolve({} as T);
  }
}
